// extracted by mini-css-extract-plugin
export default {"icon":"Details_icon__7OtE2","copied":"Details_copied__wPJjJ","fade":"Details_fade__LQzNT"};